module.exports = __webpack_public_path__ + "img/dynatrace.408e5bf9.png";